import React from "react";
import PropTypes from "prop-types";
import { UncontrolledDropdown, DropdownToggle, DropdownMenu } from "reactstrap";

import Icon from "shared/react_components/MaterialIcon";
import Slider from "shared/react_components/Slider";

import { dropdownMenu, toggle } from "./PlaybackRateDropdown.module.scss";

const PLAYBACK_RATE_MARKERS = {
  0.5: "0.5x",
  1: "1x",
  1.5: "1.5x",
  2: "2x",
  2.5: "2.5x",
  3: "3x"
};

const PlaybackRateDropdown = ({ playbackRate, onChange }) => {
  return (
    <UncontrolledDropdown>
      <DropdownToggle className={toggle}>
        {`${playbackRate}x`}<Icon name="arrow_drop_down" />
      </DropdownToggle>
      <DropdownMenu className={dropdownMenu}>
        <Slider
          defaultValue={playbackRate}
          step={0.25}
          min={0.25}
          max={3.0}
          marks={PLAYBACK_RATE_MARKERS}
          onChange={onChange}
        />
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};

PlaybackRateDropdown.propTypes = {
  playbackRate: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired
};

export default PlaybackRateDropdown;
